<template>
  <div>
    <div class="white-box mt-3">
      <div class="p30">
        <DashboardActivity :activity="dashboard?.activity" />
        <div class="row">
          <DashboardQuickAccess v-permissions="'Create Employee'" class="col-sm-6" title="User"
            description="You can add a new user here" href="/employee/add" :icon="IconUser" />
          <DashboardQuickAccess v-permissions="'Create Broadcast'" class="col-sm-6" title="Quick Broadcast"
            description="You can add a new broadcast here" href="/broadcast/add" :icon="IconBroadcast" />
        </div>
        <div class="row">
          <DashboardTarget class="col-sm-12" :target="dashboard?.target" />
          <div v-permissions="'View All Schedules'">
            <DashboardSchedule class="col-sm-12" :table-fields="DASHBOARD_ONGOING_SCHEDULE"
              endpoint-url="/schedules/ongoing" title="Ongoing Schedule" />
            <DashboardSchedule class="col-sm-12" :table-fields="DASHBOARD_ONGOING_SCHEDULE" endpoint-url="/schedules"
              title="Upcoming Schedule" :additional-params="{
                scheduled_by: 'all',
                start_date: moment().add(1, 'days').format('YYYY-MM-DD')
              }" />
          </div>
        </div>
      </div>
    </div>
    <DashboardSummary v-permissions="'View Feedback and Complaints'" />
  </div>
</template>

<script>
import axios from '@/axios'
import { DASHBOARD_ONGOING_SCHEDULE } from "@/constants/table-field.js"
import { showErrorMessage } from '@/utils'
import moment from 'moment'


import DashboardActivity from './Activity.vue'
import DashboardQuickAccess from './QuickAccess.vue'
import DashboardSchedule from './Schedule.vue'
import DashboardSummary from './Summary.vue'
import DashboardTarget from './Target.vue'

import IconBroadcast from '@/assets/img/icon-boradcast.png'
import IconUser from '@/assets/img/icon-user.png'


export default {
  components: { DashboardActivity, DashboardQuickAccess, DashboardTarget, DashboardSchedule, DashboardSummary },
  data() {
    return {
      IconUser,
      IconBroadcast,

      moment,
      dashboard: null,
      DASHBOARD_ONGOING_SCHEDULE
    }
  },
  methods: {
    getDetailDashboard() {
      axios.get('/dashboard/activity_and_target', {
        params: {
          month: moment().month(),
          year: moment().year()
        }
      }).then(res => {
        const { data } = res.data
        this.dashboard = data
      }).catch(err => {
        showErrorMessage(err)
      })
    },
  },
  created() {
    this.getDetailDashboard()
  }
}
</script>

<style></style>
